import PageWrapper from "../../components/common/layout/PageWrapper";
import { useTranslation } from "react-i18next";
import useAppSelector from "../../../hooks/redux/base/useAppSelector";
import SeAdditionalDocEdit from "../../components/services/additionalDoc/SeAdditionalDocEdit";

const SeAdditionalDocEditPage = () => {
  const { t } = useTranslation();

  const selectedService = useAppSelector((state) => {
    return state.SelectedService;
  });

  return (
    <PageWrapper title={t(`${selectedService.titleCode}.edit`)}>
      <SeAdditionalDocEdit />
    </PageWrapper>
  );
};

export default SeAdditionalDocEditPage;
